export default __webpack_public_path__ + "static/media/usc-logo.5fe164fb.jpg";